module.exports = __webpack_public_path__ + "img/charging-session-infograph-desktop-fr@2x.4438ae93.webp";